__turbopack_context__.v({
  "changeNumberBtn": "CompactOtpField-module-scss-module__AjctIa__changeNumberBtn",
  "field": "CompactOtpField-module-scss-module__AjctIa__field",
  "fieldCompact": "CompactOtpField-module-scss-module__AjctIa__fieldCompact",
  "label": "CompactOtpField-module-scss-module__AjctIa__label",
  "numberChip": "CompactOtpField-module-scss-module__AjctIa__numberChip",
  "numberChipValue": "CompactOtpField-module-scss-module__AjctIa__numberChipValue",
  "otpContainer": "CompactOtpField-module-scss-module__AjctIa__otpContainer",
  "otpDigit": "CompactOtpField-module-scss-module__AjctIa__otpDigit",
  "otpDigitError": "CompactOtpField-module-scss-module__AjctIa__otpDigitError",
  "phoneNumber": "CompactOtpField-module-scss-module__AjctIa__phoneNumber",
  "resendBtn": "CompactOtpField-module-scss-module__AjctIa__resendBtn",
  "resendRow": "CompactOtpField-module-scss-module__AjctIa__resendRow",
  "resendTimer": "CompactOtpField-module-scss-module__AjctIa__resendTimer",
  "sentTo": "CompactOtpField-module-scss-module__AjctIa__sentTo",
});
